import React, { FC } from 'react';

export const CircleTick: FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props}>
    <circle cx="12" cy="12" r="11.5" fill="currentColor" stroke="currentColor" />
    <path
      fill="#fff"
      d="m18.367 9.082-7.746 7.745a1.024 1.024 0 0 1-1.449 0l-3.538-3.538a1.023 1.023 0 1 1 1.45-1.448l2.813 2.813 7.021-7.02a1.024 1.024 0 1 1 1.449 1.448Z"
    />
  </svg>
);
